import { render, staticRenderFns } from "./PageCompany.vue?vue&type=template&id=39f93be9&"
import script from "./PageCompany.vue?vue&type=script&lang=js&"
export * from "./PageCompany.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports